import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import LotSelectModal from "../common/LotSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
function DiscardRegModal({ title, onClose, handleRegSuccessSave, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    discard_id: null,
    discard_number: '',
    discard_date: appStore.YYYY_MM_DD(),
    discard_approval_user_id: null,
    discard_approval_user_name: '',
    discard_reason: ''
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isSelectLotModalOpen, setSelectLotModalOpen] = useState(false);
  const [selectLotData, setSelectLotData] = useState('');

  const handleSetting = () => {
    setLotColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {lotDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {lotAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {lotDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 160, headerAlign: 'center', align:'center' },
      { field: 'lot_discard_item_id', headerName: '품목ID', width: 0, headerAlign: 'center', align:'left' },
      { field: 'lot_discard_item_name', headerName: '품목', width: 120, headerAlign: 'center', align:'left' },
      { field: 'lot_discard_item_spec', headerName: '규격', width: 155, headerAlign: 'center', align:'left' },
      { field: 'lot_discard_save_workplace_id', headerName: 'lot_discard_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_discard_save_workplace_name', headerName: '사업장',width: 130, headerAlign: 'center'},
      { field: 'lot_discard_save_warehouse_id', headerName: 'lot_discard_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_discard_save_warehouse_name', headerName: '창고', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_discard_save_section_id', headerName: 'lot_discard_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_discard_save_section_name', headerName: '구역',width: 130, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
    
    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setLotColumnVisibilityModel({
      id: false,
      lot_no: true,
      lot_discard_item_id: false,
      lot_discard_item_name: true,
      lot_discard_item_spec: true,
      lot_discard_save_workplace_id: false,
      lot_discard_save_workplace_name: true,
      lot_discard_save_warehouse_id: false,
      lot_discard_save_warehouse_name: true,
      lot_discard_save_section_id: false,
      lot_discard_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    lot_no: true,
    lot_discard_item_id: false,
    lot_discard_item_name: true,
    lot_discard_item_spec: true,
    lot_discard_save_workplace_id: false,
    lot_discard_save_workplace_name: true,
    lot_discard_save_warehouse_id: false,
    lot_discard_save_warehouse_name: true,
    lot_discard_save_section_id: false,
    lot_discard_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<lotRows.length; i++){
      if(lotRows[i].row_type === 'A' && lotRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setLotRows((lotRows) => [...lotRows, { 
        id: Number(appStore.getMaxListID(lotRows))+1,
        lot_no: '',
        lot_discard_item_id: null,
        lot_discard_item_name: '',
        lot_discard_item_spec: '',
        lot_discard_save_workplace_id: null,
        lot_discard_save_workplace_name: '',
        lot_discard_save_warehouse_id: null,
        lot_discard_save_warehouse_name: '',
        lot_discard_save_section_id: null,
        lot_discard_save_section_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [lotRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시
    
    setSelectModalTitle('폐기승인자 목록')
    setSelectUserModalOpen(true);

  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    // 폐기 Lot Rows Update
    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.lot_no !== oldRow.lot_no){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_lot_no = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.lot_no !== ''){
          row_lot_no = newRow.lot_no;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_no !== newRow.lot_no)?
          (
            row_lot_no = data.lot_no
          ):""
        )
      }
      
      if(row_lot_no === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateLotRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateLotRows.length);
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const lotAddClick = (object) => {
    //폐기 Lot 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setLotRows((itemRows) => [...lotRows, { 
        id: Number(appStore.getMaxListID(lotRows))+1,
        lot_no: '',
        lot_discard_item_id: null,
        lot_discard_item_name: '',
        lot_discard_item_spec: '',
        lot_discard_save_workplace_id: null,
        lot_discard_save_workplace_name: '',
        lot_discard_save_warehouse_id: null,
        lot_discard_save_warehouse_name: '',
        lot_discard_save_section_id: null,
        lot_discard_save_section_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('Lot 목록')
      setSelectLotModalOpen(true);
      setSelectLotData({
        id: object.row.id,
        lot_no: object.row.lot_no,
        lot_discard_item_id: object.row.lot_discard_item_id,
        lot_discard_item_name: object.row.lot_discard_item_name,
        lot_discard_item_spec: object.row.lot_discard_item_spec,
        lot_discard_save_workplace_id: object.row.lot_discard_save_workplace_id,
        lot_discard_save_workplace_name: object.row.lot_discard_save_workplace_name,
        lot_discard_save_warehouse_id: object.row.lot_discard_save_warehouse_id,
        lot_discard_save_warehouse_name: object.row.lot_discard_save_warehouse_name,
        lot_discard_save_section_id: object.row.lot_discard_save_section_id,
        lot_discard_save_section_name: object.row.lot_discard_save_section_name,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const lotDeleteClick = (object) => {
    //폐기 Lot 삭제 버튼
    setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.id !== object.row.id));
    setLotRows((lotRows) => lotRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    //폐기 파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //폐기 파일 다운로드
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'lot_no'){
      setSelectModalTitle('Lot 목록');
      setSelectLotModalOpen(true);
      setSelectLotData({
        id: params.row.id,
        lot_no: params.row.lot_no,
        lot_discard_item_id: params.row.lot_discard_item_id,
        lot_discard_item_name: params.row.lot_discard_item_name,
        lot_discard_item_spec: params.row.lot_discard_item_spec,
        lot_discard_save_workplace_id: params.row.lot_discard_save_workplace_id,
        lot_discard_save_workplace_name: params.row.lot_discard_save_workplace_name,
        lot_discard_save_warehouse_id: params.row.lot_discard_save_warehouse_id,
        lot_discard_save_warehouse_name: params.row.lot_discard_save_warehouse_name,
        lot_discard_save_section_id: params.row.lot_discard_save_section_id,
        lot_discard_save_section_name: params.row.lot_discard_save_section_name,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };
  
  const handleUserClick = (object) => {
    const nextInputs = {
        ...inputs,
        ["discard_approval_user_id"] : object.id,
        ["discard_approval_user_name"] : object.user_name
    };
    setInputs(nextInputs);
  };

  const handleLotClick = (object) => {
    var doubleYN = 'N'
    for(let i = 0; i < lotRows.length; i++){
      if(lotRows[i].lot_no === object.item_lotno && selectLotData.lot_no !== lotRows[i].lot_no && object.item_lotno !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">Lot '+object.item_lotno+' 중복</p>',
        text: '추가된 Lot이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.item_lotno !== selectLotData.lot_no){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            lot_no: object.item_lotno,
            lot_discard_item_id: object.item_id,
            lot_discard_item_name: object.item_name,
            lot_discard_item_spec: object.item_full_spec,
            lot_discard_save_workplace_id: object.item_lot_save_workplace_id,
            lot_discard_save_workplace_name: object.item_lot_save_workplace_name,
            lot_discard_save_warehouse_id: object.item_lot_save_warehouse_id,
            lot_discard_save_warehouse_name: object.item_lot_save_warehouse_name,
            lot_discard_save_section_id: object.item_lot_save_section_id,
            lot_discard_save_section_name: object.item_lot_save_section_name,
            row_type: selectLotData.row_type,
            update_type: selectLotData.update_type
          },
          {
            id: selectLotData.id,
            lot_no: selectLotData.lot_no,
            lot_discard_item_id: selectLotData.lot_discard_item_id,
            lot_discard_item_name: selectLotData.lot_discard_item_name,
            lot_discard_item_spec: selectLotData.lot_discard_item_spec,
            lot_discard_save_workplace_id: selectLotData.lot_discard_save_workplace_id,
            lot_discard_save_workplace_name: selectLotData.lot_discard_save_workplace_name,
            lot_discard_save_warehouse_id: selectLotData.lot_discard_save_warehouse_id,
            lot_discard_save_warehouse_name: selectLotData.lot_discard_save_warehouse_name,
            lot_discard_save_section_id: selectLotData.lot_discard_save_section_id,
            lot_discard_save_section_name: selectLotData.lot_discard_save_section_name,
            row_type: selectLotData.row_type,
            update_type: selectLotData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    if((inputs.discard_date) === '' || (inputs.discard_date) < '2025-01-01' || (inputs.discard_date).length != 10){
      msg = '폐기일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    } 

    if(updateLotRows.length === 0){ // 폐기품목이 0개 일 경우

      msg = '폐기 품목이 존재하지 않습니다.';

    } else if(updateLotRows.length > 0 && msg === ''){ // 폐기품목 검사
      for(let i = 0; i < updateLotRows.length; i++) {
        const discard_lot_no = updateLotRows[i].lot_no;
        
        if(discard_lot_no === '') {
          msg = '선택되지 않는 LotNo 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">폐기 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Discard/Reg", {inputs, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        
        if(response.status === 200){
          var selectID = response.data;
          if(String(selectID) === '-1'){
            Swal.fire({
              title: '<p style="color:red">폐기 LotNo 변경 발생</p>',
              text: '폐기 등록할 LotNo의 변경이 발생했습니다.',
              confirmButtonText: '확인'
            });
          }else{
            
            if(updateFileRows.length > 0) {

              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'Discard');
              formData.append('type', 'Reg');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                handleRegSuccessSave(selectID);
              }).catch(error => {
                appStore.capture();
              });
              
            }else{

              handleRegSuccessSave(selectID);

            }
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="폐기 정보" value="1" />
                <Tab label="폐기 Lot" value="2" />
                <Tab label="폐기 파일" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={ {  } }>폐기번호</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '190px' } }>
                          <input type="text" placeholder="폐기번호" value={inputs.discard_number} name="discard_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                        <div className="modal_filed_title" style={ { paddingLeft: '20px', width: '100px' } }>폐기일자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '150px' } }>
                          <input type="date" placeholder="폐기일자" value={inputs.discard_date} name="discard_date" onChange={(e) => onChange(e) } autoComplete="off" style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                        <div className="modal_filed_title" style={ { paddingLeft: '30px', width: '106px' } }>폐기승인자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '170px' } }>
                          <input type="text" placeholder="폐기승인자" value={inputs.discard_approval_user_name} name="discard_approval_user_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">폐기사유</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="폐기사유" name="discard_reason" value={inputs.discard_reason} onChange={(e) => onChange(e) } style={{width: '768px', height: '200px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'       
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectLotModalOpen && (<LotSelectModal
          onClose={() => {
              setSelectLotModalOpen(false);
          }}
          title={selectmodalTitle}
          handleLotClick={handleLotClick}
          status={'C'}
          />)}
        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default DiscardRegModal;